(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    // Quick view triggers are delegated so cards added later (filtering,
  // pagination swaps) keep working without re-binding.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-view-trigger]');
    if (!trigger) return;
    document.dispatchEvent(
      new CustomEvent('quick-view:open', { detail: { handle: trigger.dataset.productHandle } })
    );
  });

  /**
   * Adds a single-variant product to the cart without leaving the page.
   *
   * The markup is a real product form, so if this script never runs — or the
   * request fails — the browser posts it and the visitor lands on the cart.
   */
  class ProductQuickAdd extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.button = this.querySelector('button[type="submit"]');
      this.label = this.querySelector('[data-quick-add-label]');
      this.original = this.label ? this.label.textContent : '';

      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.button.disabled) return;

      this.setState('adding');

      try {
        const body = new FormData(this.form);

        // Ask for the drawer's markup in the same round trip so its contents
        // stay in step with the cart. The response is keyed by exactly the id
        // requested, so it has to be the drawer's own section id rather than
        // the section's file name.
        const drawer = document.querySelector('cart-drawer[data-section-id]');
        if (drawer) body.append('sections', drawer.dataset.sectionId);

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body,
        });

        if (!response.ok) throw new Error('Add to cart failed');

        const data = await response.json();
        document.dispatchEvent(new CustomEvent('cart-drawer:render', { detail: data }));
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        this.setState('added');
      } catch (error) {
        // Hand it back to the browser rather than failing silently.
        this.form.submit();
      }
    }

    setState(state) {
      if (!this.label) return;

      if (state === 'adding') {
        this.button.disabled = true;
        this.label.textContent = this.dataset.addingLabel || 'Adding…';
        return;
      }

      this.label.textContent = this.dataset.addedLabel || 'Added';
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.label.textContent = this.original;
        this.button.disabled = false;
      }, 1600);
    }
  }

  if (!customElements.get('product-quick-add')) {
    customElements.define('product-quick-add', ProductQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    class DrawerNav extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-drawer-open]');
        if (opener) {
          this.show(opener.dataset.drawerOpen);
          return;
        }
        if (event.target.closest('[data-drawer-back]')) this.show('root');
      });
    }

    show(name) {
      this.querySelectorAll('[data-drawer-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.drawerPanel !== name;
      });

      // Send focus to the panel that just appeared.
      const active = this.querySelector(`[data-drawer-panel="${name}"]`);
      const target = active && active.querySelector('button, a');
      if (target) target.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('drawer-nav')) {
    customElements.define('drawer-nav', DrawerNav);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-localization"] && !Shopify.designMode) return;
  try {
    // One disclosure at a time, closed by anything that isn't it.
  const OPEN_TOGGLES = '[data-localization-toggle][aria-expanded="true"]';

  function setOpen(toggle, open) {
    toggle.setAttribute('aria-expanded', String(open));
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (panel) panel.hidden = !open;
  }

  function closeAll(except) {
    document.querySelectorAll(OPEN_TOGGLES).forEach((toggle) => {
      if (toggle !== except) setOpen(toggle, false);
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-localization-toggle]');

    // A click on an option submits its form; leave the panel alone so it
    // doesn't flicker shut during the navigation.
    if (!toggle && event.target.closest('[data-localization-panel]')) return;

    closeAll(toggle);
    if (!toggle) return;
    setOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector(OPEN_TOGGLES);
    if (!open) return;
    closeAll(null);
    open.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.singleView = this.dataset.singleView === 'true';
      this.zoomEnabled = this.dataset.zoom === 'true';
      this.zoomLevel = Number(this.dataset.zoomLevel) || 2;

      this.querySelectorAll('[data-thumbnail]').forEach((button) => {
        button.addEventListener('click', () => this.show(button.dataset.mediaId));
      });

      if (this.zoomEnabled) this.bindZoom();

      // The variant picker asks for a specific media item.
      document.addEventListener('product:media', (event) => {
        if (event.detail && event.detail.mediaId) this.show(event.detail.mediaId);
      });
    }

    show(mediaId) {
      /* Ignore a request for media this gallery does not hold. The variant
         event is listened for on the document, so every gallery on the page
         hears it — a quick view's as well as the page's own. Without this the
         gallery that does not have the item hides all of them (the loop below
         hides everything that is not the requested id) and goes blank. */
      const target = this.querySelector(`.product-media__item[data-media-id="${mediaId}"]`);
      if (!mediaId || !target) return;

      const buttons = Array.from(this.querySelectorAll('[data-thumbnail]'));
      buttons.forEach((thumb) => {
        thumb.setAttribute('aria-pressed', thumb.dataset.mediaId === mediaId ? 'true' : 'false');
      });

      // The counter reads a position, so it needs the index among one set of
      // buttons rather than among every control style at once.
      const counter = this.querySelector('[data-media-index]');
      if (counter) {
        const indicators = Array.from(this.querySelectorAll('.product-media__indicator'));
        const index = indicators.findIndex((button) => button.dataset.mediaId === mediaId);
        if (index > -1) counter.textContent = index + 1;
      }

      if (this.singleView) {
        this.querySelectorAll('.product-media__item').forEach((item) => {
          item.hidden = item.dataset.mediaId !== mediaId;
        });
        return;
      }

      // Stacked and grid layouts scroll the item into view instead.
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    bindZoom() {
      const dialog = this.querySelector('[data-zoom-dialog]');
      if (!dialog) return;

      /* The picture is built here rather than authored above: its dimensions
         are whatever the opened media turns out to be, so a width and height
         in the markup would be a guess that is wrong for most of them. */
      const image = document.createElement('img');
      image.className = 'product-media__lightbox-image';
      image.alt = '';
      dialog.appendChild(image);

      /* Swap the source before opening so the picture is never briefly the
         previous one. The source lives on the wrapper, so the corner button
         reads it from its own ancestor rather than carrying a duplicate. */
      const open = (trigger) => {
        if (!trigger) return;
        image.src = trigger.dataset.zoomSrc || '';
        image.alt = trigger.dataset.zoomAlt || '';
        dialog.showModal();
      };

      this.querySelectorAll('[data-zoom-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => open(trigger));
      });

      /* The button sits inside the wrapper, so its click would bubble and open
         the lightbox twice over. Stopping it there keeps one path in. */
      this.querySelectorAll('[data-zoom-open]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          open(button.closest('[data-zoom-trigger]'));
        });
      });

      /* Dropping the source stops a large picture sitting in memory for every
         gallery on the page. It is done here rather than only in a `close`
         handler because Escape is not the only way out, and the handler is
         kept as well for the way out that this code does not perform. */
      /* Magnify inside the lightbox. The picture already fits the screen, so
         this is the second step: click to go to the Maximum zoom level, move
         the pointer to pan, click again to come back out.

         Panning is done with transform-origin rather than by translating,
         because the origin maps the pointer's position straight onto the
         picture: hold the cursor over a detail and that detail is what the
         magnification grows around. */
      const resetZoom = () => {
        image.removeAttribute('data-zoomed');
        image.style.removeProperty('--zoom-origin-x');
        image.style.removeProperty('--zoom-origin-y');
      };

      const track = (event) => {
        if (!image.hasAttribute('data-zoomed')) return;
        const box = image.getBoundingClientRect();
        const x = ((event.clientX - box.left) / box.width) * 100;
        const y = ((event.clientY - box.top) / box.height) * 100;
        image.style.setProperty('--zoom-origin-x', `${Math.min(Math.max(x, 0), 100)}%`);
        image.style.setProperty('--zoom-origin-y', `${Math.min(Math.max(y, 0), 100)}%`);
      };

      image.addEventListener('click', (event) => {
        // Without this the dialog's own click handler reads the click as
        // landing beside the picture and closes the lightbox.
        event.stopPropagation();
        if (image.hasAttribute('data-zoomed')) {
          resetZoom();
        } else {
          image.style.setProperty('--zoom', this.zoomLevel);
          track(event);
          image.setAttribute('data-zoomed', '');
        }
      });

      image.addEventListener('pointermove', track);

      const dismiss = () => {
        resetZoom();
        image.removeAttribute('src');
        dialog.close();
      };

      dialog.querySelector('[data-zoom-close]')?.addEventListener('click', dismiss);

      // Clicking beside the picture closes it. The picture is centred at its
      // own size, so anything that is not the image is the space around it.
      dialog.addEventListener('click', (event) => {
        if (event.target === image) return;
        if (event.target.closest('[data-zoom-close]')) return;
        dismiss();
      });

      // Escape closes a modal dialog on its own, which reaches neither of the
      // paths above.
      dialog.addEventListener('close', () => {
        resetZoom();
        image.removeAttribute('src');
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
